
<template>
    <div>
        <template>
            <tabs fill class="flex-column flex-md-row">
                <card shadow>
                    <tab-pane 
                        title="Medical Applications"
                        @tab-activated="triggerMedicalCompletedApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-books"></i>
                            Medical Applications
                        </span>
                        <!-- import Pending Applications template here -->
                        <MedicalCompletedApplications 
                            :type="'medical'"
                            ref="callMedicalCompletedApplications"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Dental Applications"
                        @tab-activated="triggerDentalCompletedApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-badge"></i>
                            Dental Applications
                        </span>
                        <!-- import Rejected Applications template here -->
                        <!-- <DentalCompletedApplications /> -->
                        <MedicalCompletedApplications 
                            :type="'dental'"
                            ref="callDentalCompletedApplications"
                        />
                    </tab-pane>
                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
    import MedicalCompletedApplications from './CompletedApplications/MedicalCompletedApplications';
    //   import DentalCompletedApplications from './CompletedApplications/DentalCompletedApplications';

    export default {
        name: 'CompletedApplications',
        components: {
            MedicalCompletedApplications,
            // DentalCompletedApplications
        },
        methods: {
            triggerMedicalCompletedApplications() {
                if (this.$refs.callMedicalCompletedApplications && this.$refs.callMedicalCompletedApplications.loadAplications) {
                    this.$refs.callMedicalCompletedApplications.loadAplications();
                }
            },
            triggerDentalCompletedApplications() {
                if (this.$refs.callDentalCompletedApplications && this.$refs.callDentalCompletedApplications.loadAplications) {
                    this.$refs.callDentalCompletedApplications.loadAplications();
                }
            },
        }
    };
</script>
<style></style>
